import { postApi } from '../../utils/api'

export function createPassword({ data, hash }) {
  return postApi({
    data,
    endpoint: `/api/system/invite-setup-pass/${hash}/`,
  })
}

export function createPasswordAfterRecover({ data, hash }) {
  return postApi({
    data,
    endpoint: `/api/system/recover-setup-pass/${hash}/`,
  })
}

export function recoverPassword(data) {
  return postApi({
    data,
    endpoint: '/api/system/reset-password/',
  })
}

export function register(data) {
  return postApi({
    data,
    endpoint: '/api/profile/free-registration/',
  })
}

export function validateHashOnSettingPasswordAfterRegistration(hash) {
  return postApi({ endpoint: `/api/system/confirm-invite/${hash}/` })
}

export function validateHashOnSettingPasswordAfterRecover(hash) {
  return postApi({ endpoint: `/api/system/confirm-recover/${hash}/` })
}
